import React, { useRef } from "react";

import { Box, Link as MuiLink, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import useHover from "@react-hook/hover";

import { colors } from "theme";

import { ServiceOfferProps } from "./type";

export const ServiceOffer: React.FC<ServiceOfferProps> = ({
  title,
  description,
  offerUrl,
  OfferImage,
}) => {
  const target = useRef(null);
  const isHovered = useHover(target);

  return (
    <Box
      style={{
        transform: `translateY(${isHovered ? -10 : 0}px)`,
        transition: "transform .22s ease",
      }}
      bgcolor={colors.white}
      boxShadow={1}
      ref={target}
      px={{ xs: 3, md: 3.75 }}
      paddingTop={{ xs: 3, md: "45px" }}
      paddingBottom={{ xs: 4, md: "unset" }}
      height={{ xs: "auto", md: "673px", lg: "563px" }}
      boxSizing="border-box"
      display="flex"
      flexDirection="column"
      alignItems="center"
      position="relative"
    >
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        width={102}
        height={102}
      >
        <OfferImage />
      </Box>

      <Box
        mt={{ xs: 1, md: "30px" }}
        display="flex"
        flexDirection="column"
        rowGap={1}
        alignItems="center"
      >
        <Typography component="strong" variant="h5" align="center">
          {title}
        </Typography>
        <Typography variant="subtitle1" component="p">
          {description}
        </Typography>
        <Box
          height={46}
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          <Link href={offerUrl} target="_blank" variant="h5" color="secondary">
            Get started
          </Link>
        </Box>
      </Box>
    </Box>
  );
};

const Link = styled(MuiLink)({
  "&:hover": {
    color: colors.ocean[700],
  },
});
